// @ai-generated 2026-08-03T12:11:32+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import { useApiObject } from '@Hooks/useApiObject';
import { SynqoRuleSeverity, type ApiRulesetDetail } from '@Model';
import { ConditionVisitor } from './ConditionVisitor';

interface RulesetPreviewProps {
    /** Base URL of the owning service's <c>/rulesets</c> endpoint (e.g. <c>AUFTRAG_API + '/rulesets'</c>). */
    apiPath: string;
    /** Cache key so the two service variants don't share a single resource-cache slot. */
    resourceCacheKey: string;
    /** The saved ruleset to resolve. Must not be a draft — a draft references nothing yet. */
    rulesetId: string;
}

/**
 * The rule tree as it reads, resolved together with every ruleset it references.
 *
 * A component rather than a branch inside the frame because <see cref="useApiObject"/> fixes its id
 * on first render: mounting it only where the id is right is what keeps the two in step.
 */
export function RulesetPreview({ apiPath, resourceCacheKey, rulesetId }: RulesetPreviewProps) {
    const { data } = useApiObject<ApiRulesetDetail>(apiPath, resourceCacheKey, `${rulesetId}/detail`);

    if (!data) {
        return null;
    }

    return (
        <div className="flex flex-col gap-2 p-4">
            <SeverityBadge severity={data.ast.severity} />
            <ConditionVisitor node={data.ast.root} referencedRulesets={data.referenced_rulesets} />
        </div>
    );
}

function SeverityBadge({ severity }: { severity: SynqoRuleSeverity }) {
    const isHard = severity === SynqoRuleSeverity.Hard;
    const classes = isHard
        ? 'bg-(--mantine-color-warning-5)/30 text-(--mantine-color-text-7) border-(--mantine-color-warning-7)'
        : 'bg-(--mantine-color-secondary-3) text-(--mantine-color-text-5) border-(--mantine-color-outline-7)';
    const label = isHard ? 'Hart' : 'Weich';

    return <span className={`w-fit rounded border px-2 py-0.5 text-xs uppercase ${classes}`}>{label}</span>;
}
